import { getConversionInputStores } from "@/app/(application)/(normal)/create/components/input/ttv/getConversionInputStores";
import { getConversionInputNamespace } from "@/constants/namespaces";
import { useNamedPitchCorrection } from "@/lib/zustand/usePitchCorrection";
import type { Sound } from "@/types/defs/sound";
import { isAudioInputFile } from "@/utils/audioInput/is/isAudioInputFile";

export const admitTtvConversionInput = (
  sounds: Sound[],
  replacementIndexes: number[]
): boolean => {
  const stores = getConversionInputStores();
  const missing = [
    ...new Map(sounds.map((sound) => [sound.id, sound])).values(),
  ].filter(
    (sound) =>
      !stores.some((store) => {
        const input = store.getState();
        return (
          isAudioInputFile(input) &&
          input.selectedFileCover.selectedSound?.id === sound.id
        );
      })
  );
  const freeIndexes = stores.flatMap((store, index) =>
    store.getState().selectedFileCover === null ? [index] : []
  );
  const validReplacements = replacementIndexes.every((index) => {
    const input = stores[index]?.getState();
    return (
      Number.isInteger(index) &&
      input !== undefined &&
      !sounds.some(
        (sound) =>
          isAudioInputFile(input) &&
          input.selectedFileCover.selectedSound?.id === sound.id
      )
    );
  });
  const available = [...new Set([...freeIndexes, ...replacementIndexes])];
  // Admit the whole selection together: a full list must never receive half a transfer or silently lose an existing input.
  if (!validReplacements || available.length < missing.length) {
    return false;
  }
  missing.forEach((sound, position) => {
    const index = available[position];
    useNamedPitchCorrection
      .getState()
      .getNamedStore(getConversionInputNamespace(index))
      .getState()
      .unset();
    stores[index].getState().setInputSound(sound);
  });
  return true;
};
